import { CompleteActions, Props as CompleteActionProps } from 'components/AIRevision/CompleteActions'
import Styles from './Actions.module.scss'
import { FailedActions, Props as FailedActionProps } from 'components/AIRevision/FailedActions'

export type Props = CompleteActionProps & FailedActionProps

export const Actions = ({ revision, view, articleId, layerId, customPrompt, onPromptChange }: Props) => (
  <div className={Styles.actions}>
    {revision.completed && (
      <CompleteActions
        revision={revision}
        view={view}
        articleId={articleId}
        layerId={layerId}
        customPrompt={customPrompt}
        onPromptChange={onPromptChange}
      />
    )}
    {revision.failed && (
      <FailedActions
        view={view}
        revision={revision}
        articleId={articleId}
        layerId={layerId}
        customPrompt={customPrompt}
        onPromptChange={onPromptChange}
      />
    )}
  </div>
)
